import { NodeType } from '../constants/node-type';
import { AttributeApiModel } from './attribute.model';
import { DomainApiModel } from './domain.model';
import { FeatureTypeApiModel } from './feature-type.model';
import { LayerApiModel } from './layer.model';
import { SymbolApiModel } from './symbol.model';

export type NodeApiModel = {
  id: number;
  name: string;
  type: NodeType;
  parent?: { id: number; name: string };
  description: string;
  attachments: string[];
  includeInSurface: boolean;
};

export type WithParent = NodeApiModel & { parent: NodeApiModel };

export type WithAttributes = NodeApiModel & { attributes: AttributeApiModel[] };

export type WithDomains = NodeApiModel & { domains: DomainApiModel[] };

export type WithPointLayer = NodeApiModel & { pointLayer: LayerApiModel };

export type WithBreaklineLayer = NodeApiModel & { breaklineLayer: LayerApiModel };

export type WithSymbol = NodeApiModel & { symbol: SymbolApiModel };

export type WithFeatureType = NodeApiModel & { featureType: FeatureTypeApiModel };

export enum NodeRelationship {
  ATTRIBUTES = 'ATTRIBUTES',
  DOMAINS = 'DOMAINS',
  FEATURE_TYPES = 'FEATURE_TYPES',
  POINT_LAYER = 'POINT_LAYER',
  BREAKLINE_LAYER = 'BREAKLINE_LAYER',
  PARENT = 'PARENT',
  SYMBOL = 'SYMBOL',
}
